module.exports = __webpack_public_path__ + "img/feature-tile-icon-06.f5c3bb36.svg";